import React, { useCallback, useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { api } from '../api';
import { Button, Card, COLORS, Muted, Screen, Title } from '../ui';
import { getLocale, t } from '../i18n';

export default function NotificationsScreen() {
  const [notifications, setNotifications] = useState<any[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const load = useCallback(() => {
    api('/notifications')
      .then((r) => {
        setNotifications(r.notifications);
        setUnreadCount(r.unreadCount);
      })
      .catch(() => {});
  }, []);
  useFocusEffect(load);

  const markRead = async (id: string) => {
    await api(`/notifications/${id}/read`, { body: {} }).catch(() => {});
    load();
  };

  return (
    <Screen>
      <Title>{t('Известия')}{unreadCount > 0 ? ` (${unreadCount})` : ''}</Title>
      {unreadCount > 0 && (
        <Button
          title={t('Маркирай всички като прочетени')}
          variant="secondary"
          onPress={async () => {
            await api('/notifications/read-all', { body: {} });
            load();
          }}
        />
      )}
      <View style={{ height: 12 }} />
      {notifications.length === 0 && (
        <Card>
          <Muted>{t('Нямате известия.')}</Muted>
        </Card>
      )}
      {notifications.map((n) => (
        <Pressable key={n.id} onPress={() => !n.readAt && markRead(n.id)}>
          <Card style={n.readAt ? { opacity: 0.65 } : { borderColor: COLORS.primary }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={{ fontWeight: n.readAt ? '400' : '700', color: COLORS.text, flex: 1 }}>{n.title}</Text>
              {!n.readAt && <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: COLORS.primary }} />}
            </View>
            <Text style={{ color: COLORS.text, marginTop: 4 }}>{n.body}</Text>
            <Muted>{new Date(n.createdAt).toLocaleString(getLocale() === 'en' ? 'en-GB' : 'bg-BG')}</Muted>
          </Card>
        </Pressable>
      ))}
    </Screen>
  );
}
